import React, { useEffect, useMemo } from "react";
import { Grid } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";

import CustomerDetails from "./OrderDetails/CustomerDetails/CustomerDetails";
import OrderHistoryDetails from "./OrderDetails/OrderHistoryDetails/OrderHistoryDetails";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getCustomerDetailsAsync } from "./reduxSlice/actionsAsync";
import {
  selectCustomerDetails,
  selectCustomerDetailsLoaded,
} from "./reduxSlice/selector";
import { clinicalReviewActions } from "./reduxSlice";

import "./OrderDetails/index.scss";

const ClinicalReviewCustomerRecordPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { customerId = "" } = useParams<{ customerId?: string }>();
  const customerDetails = useAppSelector(selectCustomerDetails);
  const customerDetailsLoader = useAppSelector(selectCustomerDetailsLoaded);
  const parsedCustomerId = useMemo(() => Number(customerId), [customerId]);
  const hasValidNumericCustomerId = Number.isFinite(parsedCustomerId);

  useEffect(() => {
    dispatch(clinicalReviewActions.clearCustomerContext());

    if (customerId) {
      dispatch(getCustomerDetailsAsync({ customerId }));
    }
  }, [customerId, dispatch]);

  return (
    <>
      <button className="back-button mt-16 mb-16" onClick={history.goBack}>
        Back
      </button>
      <Grid container className="crp_container">
        <Grid item xs={12} sm={4} lg={3} className="crp_customer_details">
          <CustomerDetails
            customerId={hasValidNumericCustomerId ? parsedCustomerId : -1}
            customerDetails={customerDetails}
            loading={customerDetailsLoader}
          />
        </Grid>
        <Grid item xs={12} sm={8} lg={9}>
          {hasValidNumericCustomerId && (
            <OrderHistoryDetails customerId={parsedCustomerId} orderId={0} />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ClinicalReviewCustomerRecordPage;
